// src/store/index.js
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk'; // Use this middleware to handle asynchronous actions
import reducer from './reducer';

const new_store = createStore(reducer, applyMiddleware(thunk));

export default new_store;